<template>
    <div class="home">
        <v-content>
            <FeedbackForm/>
        </v-content>
    </div>
</template>

<script>
    import FeedbackForm from "../components/FeedbackForm";

    export default {
        name: 'Home',
        components: {
            FeedbackForm
        },
    }
</script>
